/**
 * Spec 157 (CC-53921) — a page may refuse a file built from its grid's view when it
 * cannot vouch for the rows in it. The view the page publishes then carries
 * `clientExportRefusal(format)` → the reason (a sentence the user reads after
 * "Export failed: "), or null to build the file as usual; `format` is 'csv',
 * 'xlsx' or 'pdf'.
 *
 * Why it exists: a client-built CSV or Excel carries LEAF rows only, so anything a
 * page says on a section heading never reaches it. The General Ledger marks a
 * section cb-api could not verify on its heading; a CSV/Excel built from that view
 * would carry the section's running balances under Amount as numbers with nothing
 * saying so. Only the General Ledger sets it. A view without it builds exactly as
 * before, and the server export never consults it — the page's own download decides
 * that.
 *
 * Its own module (not exportClientView.js) because a dozen suites mock
 * exportClientView with a fixed export list, and a new named export there would be
 * missing from every one of those mocks.
 */
export function clientExportRefusal(view, format) {
  const refuse = view?.clientExportRefusal
  if (typeof refuse !== 'function') return null
  const why = refuse(format)
  return typeof why === 'string' && why.trim() !== '' ? why : null
}
